import { createReducer } from "redux-act";
import createAction from "./utils/createMetaAction";
export const minimumOrfSizeUpdate = createAction("minimumOrfSizeUpdate");
export default createReducer(
  {
    [minimumOrfSizeUpdate]: (state, payload) => {
      return payload;
    }
  },
  300
);
export function getMinimumOrfSize(state) {
  return state;
}
